import {
  initialState,
  Actions,
  State,
  CREATE_INVITATION,
  CREATE_INVITATION_SUCCESS,
  CREATE_INVITATION_ERROR,
} from "../../types/invitation/create";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case CREATE_INVITATION:
      return {
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case CREATE_INVITATION_SUCCESS:
      return {
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case CREATE_INVITATION_ERROR:
      return {
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
